'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _portal = require('@rexlabs/portal');

var _cssAnimationGroup = require('@rexlabs/css-animation-group');

var _cssAnimationGroup2 = _interopRequireDefault(_cssAnimationGroup);

var _styling = require('@rexlabs/styling');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fadeIn = (0, _styling.keyframes)({
  '0%': { transform: 'scale(0.8)', opacity: 0, maxHeight: 0 },
  '100%': { transform: 'scale(1)', opacity: 1, maxHeight: 100 }
});

var fadeOut = (0, _styling.keyframes)({
  '0%': { transform: 'scale(1)', opacity: 1, maxHeight: 100 },
  '100%': { transform: 'scale(0.8)', opacity: 0, maxHeight: 0 }
});

var ToastTarget = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ToastTarget, _PureComponent);

  function ToastTarget() {
    (0, _classCallCheck3.default)(this, ToastTarget);
    return (0, _possibleConstructorReturn3.default)(this, (ToastTarget.__proto__ || (0, _getPrototypeOf2.default)(ToastTarget)).apply(this, arguments));
  }

  (0, _createClass3.default)(ToastTarget, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_portal.PortalTarget, (0, _extends3.default)({
        children: function children(_ref) {
          var children = _ref.children;
          return _react2.default.createElement(
            _cssAnimationGroup2.default,
            {
              enterAnimation: fadeIn,
              enterDuration: '300ms',
              enterTimingFunction: '',
              leaveAnimation: fadeOut,
              leaveDuration: '300ms'
            },
            children
          );
        }
      }, this.props));
    }
  }]);
  return ToastTarget;
}(_react.PureComponent), _class.defaultProps = {
  name: 'toasts'
}, _temp);
process.env.NODE_ENV !== "production" ? ToastTarget.propTypes = {
  name: _propTypes2.default.string.isRequired
} : void 0;
exports.default = ToastTarget;